import { render, staticRenderFns } from "./PlanoBimestralAEE.vue?vue&type=template&id=08b2ad1e"
import script from "./PlanoBimestralAEE.vue?vue&type=script&lang=js"
export * from "./PlanoBimestralAEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports